import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        toolbar: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 12,
        },
        communication: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
        },
        title: {
            fontSize: 16,
        },
        chip: {
            height: 22,
            fontSize: 11,
            fontWeight: 600,
            color: theme.palette.colors.white,
        },
        chipActive: {
            backgroundColor: theme.palette.success.main,
        },
        chipUpcoming: {
            backgroundColor: theme.palette.primary.main,
        },
        chipEnded: {
            backgroundColor: theme.palette.colors.greyDark,
        },
        description: {
            marginTop: 8,
            fontSize: 14,
            color: theme.palette.colors.table.text,
            whiteSpace: 'pre-line', // keeps the line breaks the OPS typed
            wordBreak: 'break-word',
        },
        details: {
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr)',
            columnGap: 24,
            rowGap: 12,
            marginTop: 12,
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: 'minmax(0, 1fr)',
            },
        },
        detail: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
        },
        detailLabel: {
            fontSize: 12,
            fontWeight: 500,
            color: theme.palette.primary.dark,
        },
        detailValue: {
            fontSize: 14,
            color: theme.palette.colors.table.text,
            wordBreak: 'break-word',
        },
        // Blue and underlined: the address opens Google Maps
        addressLink: {
            color: '#1976d2',
            textUnderlineOffset: '2px',
        },
        detailEmpty: {
            color: theme.palette.colors.greyDark,
        },
    }),
);

export default useStyles;
